//NOTE: This widget's definition is included in powerSchoolDesignSystemToolkit.ts
import { PdsAbstractInputWidget } from './pds-abstract-input-widget';
import { BasicValidationRules } from 'common-utils/interfaces';
import { pdsValidationRulesEngine } from './pds-validation-rules-engine';
import { pdsLogger } from './pds-logger';
import { pdsI18n } from './pds-i18n';
let log = pdsLogger.prependLogger(pdsLogger.requiresLogger('input-widgets'), 'pds-file-picker-widget.ts');

export class PdsFilePickerWidget extends PdsAbstractInputWidget {
  is = 'pds-file-picker-widget';

  accept: string;
  multiple: string;
  dataShowSelectedFile: string;

  //Since the inputElement.files can not be set to null or undefined, we will keep track of whether the outside developer
  //has set the modelValue to undefined.
  isModelValueDefined: boolean;

  properties = {
    //AbstractInputWidget Properties
    name: String, //We construct the id using the name property
    dataLabelText: String,
    dataButtonText: {
      type: String,
      value: pdsI18n.getText('pds|file picker widget|Choose...')
    },
    dataShowLabel: {
      type: String,
      value: null
    },
    dataShowSelectedFile: {
      type: String,
      value: 'true'
    },
    dataBadgeText: {
      type: String,
      value: '',
      observer: 'setUpBadge'
    },
    dataHelperText: {
      type: String,
      value: null
    },
    dataFieldHelpText: String,
    dataTooltipText: String,
    dataUseAlternateColorScheme: {
      type: String,
      value: 'false'
    },
    dataIsfieldonly: {
      //This is for adding a class to get rid of the bottom padding.
      type: String,
      value: 'false'
    },
    dataHideUnelevatedBadge: {
      type: String,
      value: 'false',
      observer: 'setUpBadge'
    },
    dataDisableInvalidBadgeElevation: {
      type: String,
      value: 'false',
      observer: 'setUpBadge'
    },
    //Widget specific Validation Properties
    dataIsrequired: {
      type: String,
      value: 'false',
      observer: 'setUpBadge'
    },
    dataCustomvalidate: String,
    accept: {
      type: String,
      value: null
    },
    multiple: {
      type: String, //This is a boolean string
      value: 'false'
    },
    disabled: {
      type: String,
      value: 'false'
    }
  };

  //	A FileList listing the chosen files
  get files(): FileList {
    return <FileList>this.querySelector('input').files;
  }

  //	A FileList listing the chosen files
  set files(value: FileList) {
    this.querySelector('input').files = value;
  }

  get value(): any {
    log('getting value: ' + this.fileString);
    return this.fileString;
  }

  set value(value: any) {
    log('setting value: ' + value);
    this.fileString = <string | null>value;
  }

  get modelValue(): FileList | undefined {
    log('getting model value');

    if (!this.isModelValueDefined) {
      return;
    }

    let result: HTMLInputElement = this.querySelector('input');

    if (result != null && result.files != null) {
      log(result.files);
      //In the Angular 2+ event listener, we grab event.target.modelValue
      return result.files;
    }
  }

  set modelValue(value: FileList | undefined) {
    log('setting model value');
    log(value);
    let modelValueChanged = this.setModelValue(value);
    if (modelValueChanged) {
      this.validateWidget();
      if (this.isValid && this.myErrorField != null) {
        this.showErrorMessage(false);
      }
    }
  }

  //This holds the value that shows up in the UI.
  //Use this.value to access this.
  private fileString: string | null = null;

  attached(): void {
    super.attached();
    this.isModelValueDefined = false;
  }

  ready(): void {
    super.ready();
    this.updateFileString();
  }

  chooseFile(): void {
    log('chooseFile() called');
    this.querySelector('input').click();
  }

  inputChange(): void {
    log('input change');
    this.updateFileString();
    this.isModelValueDefined = true;
    super.inputChange();
  }

  generateValidationRules(): void {
    let validationRules: BasicValidationRules = pdsValidationRulesEngine.getBasicValidationRules();
    validationRules.isText = true;
    validationRules.setProperty('isRequired', this.dataIsrequired, Boolean);

    this.validators = pdsValidationRulesEngine.getValidatorsForRules(validationRules);
    if ('dataCustomvalidate' in this) {
      this.validators.push({
        execute: this.pds.validation.getCustomValidate(this.dataCustomvalidate),
        condition: {
          element: this
        }
      });
    }
  }

  updateFileString(): void {
    log('updating file string');
    this.fileString = this.getFileString();
  }

  getFileString(): string | null {
    let fileInput: HTMLInputElement = <HTMLInputElement>this.querySelector('input');

    if (fileInput.files != null && fileInput.files.length > 0) {
      let fileNames: Array<string> = [];
      for (let i = 0; i < fileInput.files.length; i++) {
        fileNames.push(fileInput.files[i].name);
      }
      return fileNames.join(', ');
    } else {
      return null;
    }
  }

  setValue(value: string | null | undefined, skip = false): void {
    this.value = value;
  }

  /**
   * @param modelValue
   * @param skip
   * @returns returns if the model value was actually set.
   */
  setModelValue(modelValue: FileList | undefined, skip?: boolean): boolean {
    let ele = this.querySelector('input');
    if (ele != null && modelValue !== ele.files) {
      if (modelValue != null) {
        ele.files = modelValue;
        this.isModelValueDefined = true;
      } else {
        this.isModelValueDefined = false;
        ele.value = null;
        //setting ele.value to null clears the FileList in ele.files.
        //WARNING!!! ele.files isn't really null at this point. It's still a FileList object. But it's length is now 0.
      }

      if (skip !== true) {
        this.setValue(this.getFileString(), true);
      }
      return true;
    }
    return false;
  }

  getMultipleAttribute(multiple: string): string | null {
    return this.multiple === 'true' || this.multiple === 'multiple' ? 'multiple' : null;
  }
}
